import React from "react";
import "./PageLoader.css";
import SlSpinner from "@shoelace-style/shoelace/dist/react/spinner";

interface Props {
  inLayout?: boolean;
}

function PageLoader({ inLayout = false }: Props) {
  return (
    <div className={`pageLoaderContainer ${inLayout ? 'in-layout' : ''}`}>
      <SlSpinner style={{ fontSize: "2rem" }} />
    </div>
  );
}

export default PageLoader;
